"use strict";
import "jquery";
import "jquery-ui";
import "angular";
import "angular-route";
import "angular-resource";
import "angular-ui-bootstrap";
import "angular-sanitize";
import "angular-animate";
import "ui-select";
import '@svgdotjs/svg.js'
import "./directives/picklist.js";
import "./utils/graphGenerationUtil.js";
import "./algorithms/poissonDisk.js";
import "./business/stratigraphy.js";
import "./business/strata.js";
import "./business/characteristic.js";
import "./business/subCharacteristic.js";
import "./init.js";
import "./app.js";
import "./controllers/addStratigraphy.js";
import "./controllers/listArtefacts.js";
import "./controllers/main.js";
import "./controllers/modalAddArtefact.js";
import "./controllers/modalAddStrata.js";
import "./controllers/modalAddStratigraphy.js";
import "./controllers/modalAddStratigraphyInstance.js"
import "./controllers/modalDelArtefact.js";
import "./controllers/modalDelStrata.js";
import "./controllers/modalDelStratigraphy.js";
import "./controllers/modalExportStrata.js";
import "./controllers/modalSaveStrata.js";
import "./components/find-similar.component.js";
import "./controllers/pickList.js";
import "./controllers/showArtefact.js";
import "./controllers/showStrat.js";
import "./controllers/stratInterface.js";
import "./controllers/stratNewMicrostructure.js";
import "./controllers/stratNewComposition.js";
import "./controllers/stratMorphology.js";
import "./controllers/stratTexture.js";
import "./controllers/tabsStrata.js";
import "./services/services.js";
import "./directives/directives.js";
import "./dependencies/ngprogress.min.js";
import "@piworks/angular-bootstrap-toggle-switch/angular-toggle-switch.min.js";
import "@piworks/angular-bootstrap-toggle-switch/style/bootstrap3/angular-toggle-switch-bootstrap-3.css"
import 'datauri'
